var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, TextArea, List } from 'semantic-ui-react';
import Button from 'components/Button/Button';
import { isValidEmail } from 'app/helpers/globalHelpers';
import LetterAvatar from 'components/LetterAvatar';
import { beginInvition } from 'app/actions/sandboxItemActions';
import { closeModal } from '../../actions/modalActions';
var SandboxInvite = /** @class */ (function (_super) {
    __extends(SandboxInvite, _super);
    function SandboxInvite(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            email: '',
            note: '',
        };
        _this.handleInvite = _this.handleInvite.bind(_this);
        return _this;
    }
    SandboxInvite.prototype.componentDidMount = function () {
        var sandboxData = this.props.sandboxData;
        window.neo4jSandbox.analytics.lastInvitePopup = {
            seenAt: Date.now(),
            usecase: sandboxData.usecase,
        };
    };
    SandboxInvite.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var open = this.props.open;
        // Add usecase to lastInvitePopup when the popup opens
        if (!open && nextProps.open) {
            window.neo4jSandbox.analytics.lastInvitePopup.usecase =
                nextProps.sandboxData.usecase;
        }
        var _a = this.props, isSharing = _a.sandbox.isSharing, onCloseModal = _a.onCloseModal;
        if (isSharing && !nextProps.sandbox.isSharing) {
            onCloseModal();
        }
    };
    SandboxInvite.prototype.handleInvite = function () {
        var _a = this.state, email = _a.email, note = _a.note;
        var _b = this.props, sandboxHashKey = _b.sandboxData.sandboxHashKey, accessToken = _b.user.accessToken, onInviteConfim = _b.onInviteConfim;
        var _c = this.allowInvite(), error = _c[0], shouldAllowInvite = _c[1];
        if (!shouldAllowInvite) {
            this.setState({ error: error });
            return;
        }
        var params = { email: email, message: note, sandboxHashKey: sandboxHashKey };
        onInviteConfim(accessToken, params);
    };
    SandboxInvite.prototype.allowInvite = function () {
        var error = null;
        var email = this.state.email;
        var sandboxData = this.props.sandboxData;
        if (!isValidEmail(email))
            error = 'Please enter a valid email';
        if (!error) {
            var index = __spreadArray(__spreadArray([], sandboxData.invitedUsers, true), sandboxData.pendingInvites, true).findIndex(function (u) { return u.email === email; });
            if (index > -1)
                error = 'User has already been invited';
        }
        return [error, !error];
    };
    SandboxInvite.prototype.render = function () {
        var _this = this;
        var _a = this.props, open = _a.open, onClose = _a.onClose, _b = _a.sandboxData, _c = _b.invitedUsers, invitedUsers = _c === void 0 ? [] : _c, _d = _b.pendingInvites, pendingInvites = _d === void 0 ? [] : _d, isSharing = _a.sandbox.isSharing;
        var pending = pendingInvites.map(function (i) { return (__assign(__assign({}, i), { isPending: true })); });
        var invites = __spreadArray(__spreadArray([], invitedUsers, true), pending, true);
        var error = this.state.error;
        return (React.createElement(Modal, { open: open, onClose: onClose, size: "tiny", closeIcon: true },
            React.createElement(Modal.Header, null, "Invite Team"),
            React.createElement(Modal.Content, { scrolling: true },
                React.createElement(Form, null,
                    React.createElement(Form.Field, null,
                        React.createElement("label", null, "Email *"),
                        React.createElement(Form.Input, { type: "email", onChange: function (e, _a) {
                                var value = _a.value;
                                return _this.setState({ email: value });
                            } }),
                        error && React.createElement("div", { className: "error mb2 color-danger" }, error)),
                    React.createElement(Form.Field, { control: TextArea, label: React.createElement("label", null,
                            "Note",
                            ' ',
                            React.createElement("span", { className: "font-aluminum font-regular" }, "(optional)")), onChange: function (e, _a) {
                            var value = _a.value;
                            _this.setState({ note: value });
                        } }),
                    React.createElement(Form.Field, null,
                        React.createElement(Button, { color: "blue", size: "small", onClick: this.handleInvite, loading: isSharing }, "Send Invite"))),
                invites && invites.length > 0 && (React.createElement("div", null,
                    React.createElement("h4", { className: "mt4 mb2 color-aluminum" },
                        "Invited (",
                        invites.length,
                        ")"),
                    React.createElement(List, { divided: true, relaxed: true, verticalAlign: "middle" }, invites.map(function (invitedUser, index) { return (React.createElement(List.Item, { key: invitedUser.email + index, className: "pb3 pt3" },
                        React.createElement(List.Icon, { verticalAlign: "middle" },
                            React.createElement(LetterAvatar, { name: invitedUser.first_name || invitedUser.email, size: 36 })),
                        React.createElement(List.Content, { verticalAlign: "middle" },
                            invitedUser.email,
                            React.createElement(List.Description, { className: "font-x-small color-aluminum mt1" }, invitedUser.isPending && 'pending')))); })))))));
    };
    return SandboxInvite;
}(Component));
var mapDispatchToProps = function (dispatch) { return ({
    onInviteConfim: function (accessToken, params) { return dispatch(beginInvition(accessToken, params)); },
    onCloseModal: function () { return dispatch(closeModal()); },
}); };
var mapStateToProps = function (state) { return ({
    sandboxData: state.activeModal.data,
    user: state.user,
    sandbox: state.sandbox,
}); };
export default connect(mapStateToProps, mapDispatchToProps)(SandboxInvite);
